import { organizationsRepo } from '@/constants/providers';
import { BusinessAreasKey } from '@/modules/BusinessAreas/queries/keys';
import { CompanyKeys } from '@/modules/Companies/queries';
import { TaskKey } from '@/modules/Tasks/queries';
import { UserKey } from '@/modules/Users/queries/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AttachUserOrganizationModel } from '../types/attach-user-entity-model';
import { OrganizationKeys } from './keys';

export const useAttachUserOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation<void, unknown, AttachUserOrganizationModel>(
    (attachUserOrganizationModel) =>
      organizationsRepo.attachUserOrganization(attachUserOrganizationModel),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(OrganizationKeys.ALL);
        queryClient.invalidateQueries(BusinessAreasKey.ALL);
        queryClient.invalidateQueries(CompanyKeys.ALL);
        queryClient.invalidateQueries(TaskKey.ALL);
        queryClient.invalidateQueries(UserKey.ALL);
      },
    },
  );
};
